
<f-dialog
    v-if          = "incident"
    v-model       = "value"
    :width        = "950"
    :hide-actions = "false"
    :show-header  = "false"
    :show-save    = "false"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <div class="inc-history mt-3 mb-3">
            <div
                v-for="(step,index) in history"
                :key="index"
                :class="index===0?'':'mt-4'"
            >
                <div class="inc-history-step primary white--text" v-if="step.entries.length > 0">
                    {{ step.name }}
                </div>

                <div
                    v-for="entry in step.entries"
                    :key = "entry.id"
                >
                    <div>
                        <div class="history-unit">
                            {{ entry.unit.fabricNo }} - {{ $t('top.site.location', [ entry.unit.street, entry.unit.zip, entry.unit.city ]) }}
                        </div>
                        <c-inc-status-history
                            v-if     = "entry.history.length > 0"
                            :history = "entry.history"
                            style    = "margin-left: 10px"
                        />
                    </div>
                </div>


                <div v-for="(bid, idx) in step.bids" :key="idx" class="mt-2">
                    <div class="inc-history-bid  primary--text" :class="idx===0?'':'mt-4'">
                        {{ $t("repair.bid.name." + bid.name) }}
                        <i v-if="bid.favorite" class="fas fa-star ml-2"></i>
                    </div>
                    <c-inc-status-history :history="bid.history" style="margin-left: 10px"/>
                </div>
            </div>
        </div>
    </template>
</f-dialog>
